export default [  
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/modules/Dashboard'),
    meta: {
      requiresAuth:true,
      layout: 'app',
      breadcrumb: [
        { text: 'Dashboard' }
      ]
    }
  },
]